import React from "react";
import {ChangeUserInfoComponents} from "../Components/ChangeUserInfoComponents";
import MySignUp from "./MySignUp";
import {Auth} from "aws-amplify";
import axiosBase from "axios";
import APP_ENV from "../Environment";
import {subYears} from "date-fns";
import format from 'date-fns/format'
import {oidcUserlogout} from "../Logics/oauth";

export default class ChangeUserInfo extends MySignUp  {
    constructor() {
        super();
        this.state = {
            name01: "",
            name02: "",
            name03: "",
            kana01: "",
            kana02: "",
            birth: new Date(),
            sex: "1",
            men_checked: true,
            women_checked: false,
            mailmaga_flg: "2",
            mailmaga_demand_checked: true,
            mailmaga_undemand_checked: false,
            zip: "",
            pref: "",
            addr01: "",
            addr02: "",
            addr03: "",
            tel: "",
            get_current_user_info_flg: false,
            action_type: "",
            open_modal: false,
            execute_method: "",
            modal_title: "",
            modal_message: "",
            id_token: "",
            user: null
        };
        this._validAuthStates = ['ChangeUserInfo'];
        this.updateUserInfo = this.updateUserInfo.bind(this);
        this.handlePutOauth = this.handlePutOauth.bind(this);
        this.handleDeleteOauth = this.handleDeleteOauth.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleExecuteOauth = this.handleExecuteOauth.bind(this);
    }

    async getCurrentUserAttribute() {
        try {
            let user = await Auth.currentAuthenticatedUser();
            // 通常ログイン遷移した場合のトークンリフレッシュ処理(最新のユーザ情報を取得)
            const { refreshToken } = user.getSignInUserSession();
            if (refreshToken) {
                await user.refreshSession(refreshToken, async (err, session) => {
                    if (session) {
                        let refresh_user = session.idToken.payload;
                        user = refresh_user
                    } else {
                        user = await Auth.currentSession();
                    }
                    this.fetch_user_info(user);

                });

            } else {
                user = await Auth.currentSession();
                this.fetch_user_info(user);

            }

        } catch (e) {
            // amplifyのセッションからユーザ情報が取得できなかった場合(oidcログインで遷移した場合)
            const axios = axiosBase.create({
                baseURL: APP_ENV.BFF,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("token_res")}`
                },
                responseType: 'json'
            });
            let res = await axios.get(APP_ENV.BFF + "/oauth")
            let user = res.data;
            this.fetch_user_info_by_oauth(user);

        }
    }

    fetch_user_info_by_oauth(user) {
        let action_type = "";
        if (this.props.authData && this.props.authData.action_type === 'connect_oauth') {
            action_type = this.props.authData.action_type;
        } else if (user && user.identities) {
            action_type = "connected_oauth";
        } else if (this.state.action_type) {
            action_type = this.state.action_type;
        }
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("token_res")}`
            },
            responseType: 'json'
        });
        this.setState({
            get_current_user_info_flg: true,
            action_type: action_type,
            id_token: localStorage.getItem("token_res"),
            user: user
        });
        const params = {customer_id: user["custom:ecc_customer_id"]};
        this.commonFetchUserInfoProcess(axios, params);
    }

    fetch_user_info(user) {
        let action_type = "";
        if (this.props.authData && this.props.authData.action_type === 'connect_oauth') {
            action_type = this.props.authData.action_type;
        } else if (user.idToken.payload && user.idToken.payload.identities) {
            action_type = "connected_oauth";
        } else if (this.state.action_type) {
            action_type = this.state.action_type;
        }
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${user.idToken.jwtToken}`
            },
            responseType: 'json'
        });
        this.setState({
            get_current_user_info_flg: true,
            action_type: action_type,
            id_token: user.idToken.jwtToken
        });
        const params = {customer_id: user.idToken.payload["custom:ecc_customer_id"]};
        this.commonFetchUserInfoProcess(axios, params);
    }


    commonFetchUserInfoProcess(axios, params) {
        axios.post(APP_ENV.BFF + "/user/edit", params)
            .then((res) => {
                this.setCurrentUserInfo(res);
            })
            .catch((e) => {
            });
    }

    setCurrentUserInfo(res) {
        let zip = '';
        let tel = '';
        Object.keys(res.data).forEach((key) => {
            if (key === "sex") {
                if (res.data[key] === 1) {
                    this.setState({
                        men_checked: true,
                        women_checked: false,
                        sex: String(res.data[key])
                    });
                } else if (res.data[key] === 2) {
                    this.setState({
                        men_checked: false,
                        women_checked: true,
                        sex: String(res.data[key])
                    });

                }
            } else if (key === "mailmaga_flg") {
                if (res.data[key] === 2) {
                    this.setState({
                        mailmaga_demand_checked: true,
                        mailmaga_undemand_checked: false,
                        mailmaga_flg: String(res.data[key])
                    });
                } else if (res.data[key] === 3) {
                    this.setState({
                        mailmaga_demand_checked: false,
                        mailmaga_undemand_checked: true,
                        mailmaga_flg: String(res.data[key])
                    });
                }
            } else if (key === "birth") {
                let birth = null;
                if (res.data[key] !== "") {
                    const parts = res.data[key].split('-');
                    const date = new Date(parts[0], parts[1] - 1, parts[2]);
                    birth = date;
                } else {
                    birth = subYears(new Date(), 30)
                }
                this.setState({birth});
            } else if (key === "zip01" || key === "zip02") {
                if (!zip) {
                    zip = res.data[key]
                } else {
                    zip += "-" + res.data[key]
                }
                this.setState({
                    zip: zip
                });
            } else if (key === "tel01" || key === "tel02" || key === "tel03") {
                if (!tel) {
                    tel = res.data[key]
                } else {
                    tel += "-" + res.data[key]
                }
                this.setState({
                    tel: tel
                });
            } else {
                this.setState({
                    [key]: res.data[key]
                });
            }
        });
    }

    async componentDidUpdate() {
        if (this.props.authState === "ChangeUserInfo" && !this.state.get_current_user_info_flg) {
            this.getCurrentUserAttribute()
        }
    }

    async componentDidMount() {
        if (this.props.authState === "ChangeUserInfo" && !this.state.get_current_user_info_flg) {
            this.getCurrentUserAttribute()
        }
    }

    validate() {
        let err  = "";
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            window.scrollTo(0, 0);
            err = "入力誤りがあります。";
            this.forceUpdate();
        }
        return err;
    }

    get_attributes(tmp_attributes) {
        let offline_attributes = {};
        const attributes_fields = ["email","name01","name02","name03","kana01","kana02","kana03","sex","birth","mailmaga_flg","tel","zip","pref","addr01","addr02","addr03"];

        // signUp用の引数attributesを作成
        attributes_fields.forEach(key => {
            if (key === "zip" && tmp_attributes[key] !== "") {
                const zips = tmp_attributes[key].split(/[-]/);
                offline_attributes["zip01"] = zips[0];
                offline_attributes["zip02"] = zips[1];
            } else if (key === "tel" && tmp_attributes[key] !== "") {
                const tels = tmp_attributes[key].split(/[-]/);
                offline_attributes["tel01"] = tels[0];
                offline_attributes["tel02"] = tels[1];
                offline_attributes["tel03"] = tels[2];
            } else {
                offline_attributes[key] = tmp_attributes[key]
            }
        });
        return offline_attributes;
    }
    create_attributes_param() {
        let tmp_attributes = {};
        // まず共通で必要な属性値をキーと値の形でオブジェクト化
        for (let key of Object.keys(this.state)) {
            tmp_attributes[key] = this.state[key];
        }
        Object.assign(tmp_attributes, {
            birth: format(this.state["birth"], 'yyyy-MM-dd')
        });
        return this.get_attributes(tmp_attributes);
    }

    async updateUserInfo() {
        const err = this.validate();
        if (err !== "" ) {
            window.scrollTo(0, 0);
            this.error(err);
            return;
        }
        const offline_attributes = this.create_attributes_param();
        try {
            const user = await Auth.currentAuthenticatedUser();
            const user_info_param = {
                offline_attributes,
                sub: user.attributes.sub,
                customer_id: user.attributes["custom:ecc_customer_id"],
            };
            this.updateUser(user, user_info_param);

        } catch (e) {
            const user_info_param = {
                offline_attributes,
                sub: this.state.user.sub,
                customer_id: this.state.user["custom:ecc_customer_id"],
            };
            const id_token = this.state.id_token;
            this.updateUserByOauth(id_token, user_info_param)
        }

    }

    updateUser(user, user_info_param) {
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
            },
            responseType: 'json'
        });
        axios.put(APP_ENV.BFF + "/user", user_info_param)
            .then(() => {
                window.history.replaceState('','','/');
                // 更新成功画面を表示
                this.changeState('CompChangeUserInfo', user);
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                this.error("ユーザ情報の更新に失敗しました");
            });
    }

    updateUserByOauth(id_token, user_info_param) {
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${id_token}`
            },
            responseType: 'json'
        });
        axios.put(APP_ENV.BFF + "/user", user_info_param)
            .then(() => {
                window.history.replaceState('','','/');
                // 更新成功画面を表示
                this.changeState('CompChangeUserInfo');
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                this.error("ユーザ情報の更新に失敗しました");
            });
    }

    handleClose() {
        this.setState({ open_modal: false });
    }

    handlePutOauth() {
        this.setState({
            open_modal: true,
            execute_method: "putOauth",
            modal_title: "研究参加への同意解除",
            modal_message: "研究参加への同意のみを解除しますか？",
        });

    }

    handleDeleteOauth() {
        this.setState({
            open_modal: true,
            execute_method: "deleteOauth",
            modal_title: "楽天連携解除",
            modal_message: "楽天ID連携を解除しますよろしいですか？",
        });

    }

    handleExecuteOauth() {
        this.setState({
            open_modal: false,
        });
        if (this.state.execute_method === 'putOauth') {
            this.putOauth();
        } else if (this.state.execute_method === 'deleteOauth') {
            this.deleteOauth();
        } else if (this.state.execute_method === 'backLogin') {
            window.history.replaceState('','','/');
            this.changeState("signIn")
        }
    }

    async putOauth() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            const id_token = user.signInUserSession.idToken.jwtToken;
            this.executePutOauth(id_token);

        } catch (e) {
            const id_token = this.state.id_token;
            this.executePutOauth(id_token);

        }

    }

    executePutOauth(id_token) {
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${id_token}`
            },
            responseType: 'json'
        });
        axios.put(APP_ENV.BFF + "/oauth")
            .then(() => {
                this.setState({
                    action_type: 'unconnect_oauth_only_research_permit'
                });
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                this.error("研究参加への同意解除に失敗しました");
            });
    }

    async deleteOauth() {
        let open_modal = false;
        let execute_method = "";

        try {
            const user = await Auth.currentAuthenticatedUser();
            const id_token = user.signInUserSession.idToken.jwtToken;
            this.executeDeleteOauth(id_token, open_modal, execute_method);

        } catch (e) {
            open_modal = true;
            execute_method = "backLogin";

            const id_token = this.state.id_token;
            this.executeDeleteOauth(id_token, open_modal, execute_method);

        }

    }

    executeDeleteOauth(id_token, open_modal, execute_method) {
        const axios = axiosBase.create({
            baseURL: APP_ENV.BFF,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${id_token}`
            },
            responseType: 'json'
        });
        axios.delete(APP_ENV.BFF + "/oauth")
            .then(() => {
                this.setState({
                    action_type: 'unconnect_oauth',
                    open_modal, execute_method
                });
                oidcUserlogout().then(() => console.log("success")).catch(() => console.log("failure"))
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                this.error("楽天ID連携解除に失敗しました");
            });
    }

    showComponent(theme) {
        return (
            <ChangeUserInfoComponents theme={theme}
                                      authState={this.props.authState}
                                      name01={this.state.name01}
                                      handleInputChangeSignUp={this.handleInputChangeSignUp}
                                      name02={this.state.name02}
                                      name01_err_msg={this.validator.message('name01', this.state.name01, 'required')}
                                      name02_err_msg={this.validator.message('name02', this.state.name02, 'required')}
                                      kana01={this.state.kana01} kana02={this.state.kana02}
                                      kana01_err_msg={this.validator.message('kana01', this.state.kana01, 'required')}
                                      kana02_err_msg={this.validator.message('kana02', this.state.kana02, 'required')}
                                      kana_err_msg={this.validator.message('kana01', {kana01: this.state.kana01,kana02: this.state.kana02}, 'kana_confirm')}
                                      name03={this.state.name03}
                                      name03_err_msg={this.validator.message('name03', this.state.name03, 'required')}
                                      birth={this.state.birth} handleBirthChange={this.handleBirthChange}
                                      birth_err_msg={this.validator.message('birth', this.state.birth, 'required')}
                                      menChecked={this.state.men_checked} handleRadioClick={this.handleRadioClick}
                                      womenChecked={this.state.women_checked}
                                      mailmagaDemandChecked={this.state.mailmaga_demand_checked}
                                      handleRadioMailMagaClick={this.handleRadioMailMagaClick}
                                      mailmagaUndemandChecked={this.state.mailmaga_undemand_checked}
                                      handleZipChange={this.handleZipChange} zip={this.state.zip}
                                      zip_err_msg={this.validator.message('zip', this.state.zip, 'required|post_code_confirm')}
                                      pref={this.state.pref} callbackfn={prefacture =>
                <option key={prefacture.code} value={prefacture.code}>
                    {prefacture.name}
                </option>} addr01={this.state.addr01}
                                      addr01_err_msg={this.validator.message('addr01', this.state.addr01, 'required')}
                                      addr02={this.state.addr02}
                                      addr02_err_msg={this.validator.message('addr02', this.state.addr02, 'required')}
                                      addr03={this.state.addr03} tel={this.state.tel}
                                      tel_err_msg={this.validator.message('tel', this.state.tel, 'required|telephone_confirm')}
                                      updateUserInfo={this.updateUserInfo}
                                      handlePutOauth={() => this.handlePutOauth()}
                                      handleDeleteOauth={() => this.handleDeleteOauth()}
                                      handleClose={this.handleClose}
                                      handleExecuteOauth={this.handleExecuteOauth}
                                      action_type={this.state.action_type}
                                      open_modal={this.state.open_modal}
                                      execute_method={this.state.execute_method}
                                      modal_title={this.state.modal_title}
                                      modal_message={this.state.modal_message}
                                      history_back={() => {
                                                                          window.history.back(-1);
                                                                          return false;
                                              }}
                                      handleOnBlur={this.handleOnBlur}
            />
        )
    }
}